var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11816 12.2939L6.11816 9.47042",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8232 12.2939L10.8232 9.47042",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.76465H16.9412V4.76465C15.7321 4.76465 15.1276 4.76465 14.6738 5.0174C14.3489 5.19841 14.0808 5.46647 13.8998 5.79144C13.6471 6.24522 13.6471 6.84974 13.6471 8.05877V12.9999C13.6471 14.8856 13.6471 15.8284 13.0613 16.4142C12.4755 16.9999 11.5327 16.9999 9.64706 16.9999H7.29412C5.4085 16.9999 4.46569 16.9999 3.8799 16.4142C3.29412 15.8284 3.29412 14.8856 3.29412 12.9999V8.05877C3.29412 6.84974 3.29412 6.24522 3.04136 5.79144C2.86035 5.46647 2.5923 5.19841 2.26733 5.0174C1.81354 4.76465 1.20903 4.76465 0 4.76465V4.76465Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11736 1.9414C6.11736 1.9414 6.58795 1 8.4703 1C10.3527 1 10.8232 1.94118 10.8232 1.94118",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.00c5bdb3778b4f4894602874a6a2f8e6.svg";
export { ForwardRef as ReactComponent };